import Cookies from 'universal-cookie';
import { matchPath } from 'react-router-dom';
import unorm from 'unorm';
import CONSTANT from '../constant/constant';
import { exportFileAction } from '../actions/commonAction';

const cookies = new Cookies();

const functionCommon = {};

const timeOut = 60*24;

functionCommon.requireAuth = () => {
    const info = cookies.get('info');
    let flag = '';
    if (!info) {
        flag = false;
    }
    if (info && info['token']) {
        flag = true;
    }
    return flag;
}

functionCommon.logout = () => {
    cookies.remove('info', {path: "/"});
    localStorage.removeItem("RequestApiTime");
    window.location = '/';
}

functionCommon.getRole = () => {
    const info = cookies.get('info');
    if (info && info['role']) {
        return info['role'];
    } else {
        return '';
    }
}

functionCommon.getLevel = () => {
    const info = cookies.get('info');
    if (info && info['level']) {
        return info['level'];
    } else {
        return '';
    }
}

functionCommon.getCurrentPath = (pathname, _path) => {
    const match = matchPath(
        pathname,
        { path: _path }
      );
    return match.params.code;
}

functionCommon.checkRequestApiTime = () => {
    let RequestApiTime = localStorage.getItem("RequestApiTime");
    let startDate = new Date();
    let endDate = new Date(RequestApiTime);
    if (!RequestApiTime) {
        localStorage.setItem("RequestApiTime", startDate);
        return false;
    } else {
        const check = functionCommon.msToTime(startDate.getTime() - endDate.getTime());
        if (check > timeOut) {
            return true;
        } else {
            localStorage.setItem("RequestApiTime", startDate);
            return false;
        }
    }
}

functionCommon.setRequestApiTime = () => {
    let startDate = new Date();
    localStorage.setItem("RequestApiTime", startDate);
}

functionCommon.msToTime = (duration) => {
    const minutes = Math.floor((duration / (1000 * 60)));
    return minutes;
}

functionCommon.validatePassword = (value) => {
    let regex = new RegExp("^(?=.*[A-Z])(?=.*[!@#\$%\^&\*])(?=.{8,})");
    let isValidate = regex.test(value) ? true : false;
    return isValidate;
}

functionCommon.validateEmail = (value) => {
    return /^[a-z][a-zA-Z0-9_\.-]{1,32}@[a-zA-Z0-9-]{2,}(\.[a-z0-9]{2,4}){1,2}$/.test(value);
}

functionCommon.checkfile = (file) => {
    let ext = file.name.match(/\.([^\.]+)$/)[1];
    if(ext === 'xlsx' || ext === 'xls' || ext === 'xlsm' ){
        return true
    }else{
        return false
    }
}

functionCommon.dateInMonth = (month, year) => {
    let monthIndex = month - 1;
    let names = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    let date = new Date(year, monthIndex, 1);
    let result = [];
    while (date.getMonth() == monthIndex) {
        result.push({
            dateConvert:names[date.getDay()] + "_" + date.getDate(),
            isSunOrSa: (names[date.getDay()] == 'Sun' || names[date.getDay()] == 'Sat') ? true : '',
            date:  year + '-' + ("0" + month).slice(-2) + '-' + ("0" + date.getDate()).slice(-2) + " 00:00:00",
            day: ("0" + date.getDate()).slice(-2)
        });
        date.setDate(date.getDate() + 1);
    }
    return result;
}
functionCommon.getInfoUser = (value) => {
    const info = cookies.get('info');
    return info[value];
}

functionCommon.isDecimal = (value) => {
    return /^[-+]?[0-9]+\.[0-9]+$/.test(value)
}

functionCommon.validateDecimal = (value) => {
   return /^-?(?:\d+|\d{1,3}(?:,\d{3})+)(?:(\.|,)(?:\d{1}|\d{2}))?$/.test(value)
}

functionCommon.convertVie = (str) => {
   return unorm.nfd(str).replace(/[\u0300-\u036f]/g, "").replace(/đ/g, "d").replace(/Đ/g, "D");
}

functionCommon.onInputNumberPositive = (event, isDot = false) => {
    let result = event.target.value;
    const regex = isDot ? /^[0-9]*\.?[0-9]*$/ : /^[0-9]*?[0-9]*$/;
    if (!regex.test(String(result))) {
        result = result.slice(0, result.length - 1);
    }
    return result;
};

functionCommon.onPasteNumber = (event, isDot = false) => {
    const regex = isDot ? /^[0-9]*\.?[0-9]*$/ : /^[0-9]*?[0-9]*$/
    if (!regex.test(event.clipboardData.getData("Text"))) {
        // Control paste value
        event.preventDefault();
    }
};

functionCommon.onKeyDownNumber = (event, isDot = false) => {
    // Using keydown because keypress is nolonger support
    const ignoreKey = [
        "Backspace",
        "Control",
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown",
        "Tab",
        "Alt",
        "Enter",
        "Shift",
    ];
    isDot && ignoreKey.push(".")
    if (ignoreKey.findIndex((ele) => ele === event.key) < 0 && !event.ctrlKey) {
        if (!/^\d+$/.test(event.key)) {
            // Prevent "e" character on PC mode
            event.preventDefault();
        }
    }
};

functionCommon.revertDateFormat = (date) => {
    return date ? date.split("-").reverse().join("-") : "";
};

functionCommon.goToPage = (url) => () => {
    setTimeout(function () {
        window.location = url;
    }, 500);
};

functionCommon.parseQuery = (object) => {
    return Object.keys(object)
        .map((key) => key + "=" + object[key])
        .join("&");
};

functionCommon.onKeyDownDateInput = (event) => {
    event.preventDefault();
};

functionCommon.onMouseEnterDateInput = (id) => {
    const list = document.getElementsByClassName("leave-date-input-restrict");
    Array.from(list).forEach((element) => {
        element.addEventListener("contextmenu", (e) => {
            e.preventDefault();
        });
    });
};

functionCommon.onMouseLeaveDateInput = (id) => {
    const list = document.getElementsByClassName("leave-date-input-restrict");
    Array.from(list).forEach((element) => {
        element.removeEventListener(
            "contextmenu",
            (e) => {
                e.preventDefault();
            },
            false
        );
    });
};

functionCommon.removeVNCharacter = (str, c = '-') => {
    str= str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g,"a");  
    str= str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g,"e");  
    str= str.replace(/ì|í|ị|ỉ|ĩ/g,"i");  
    str= str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g,"o");  
    str= str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g,"u");  
    str= str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g,"y");  
    str= str.replace(/đ/g,"d");

    str= str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g,"A");  
    str= str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g,"E");  
    str= str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g,"I");  
    str= str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g,"O");  
    str= str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g,"U");  
    str= str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g,"Y");  
    str= str.replace(/Đ/g,"D");
    
  return str;
};

functionCommon.filterEmployee = (input, option) => {
  const searchText = input.toLowerCase();
  const targetText = option.props.label.toLowerCase();
  const haveAccent =
    /[àáãảạăằắẳẵặâầấẩẫậèéẻẽẹêềếểễệđùúủũụưừứửữựòóỏõọôồốổỗộơờớởỡợìíỉĩịäëïîöüûñçýỳỹỵỷ]/g.test(
      searchText,
    );

  if (haveAccent) {
    return targetText.indexOf(searchText) >= 0;
  } else {
    return (
      functionCommon
        .removeVNCharacter(targetText)
        .indexOf(functionCommon.removeVNCharacter(searchText)) >= 0
    );
  }
};

export default functionCommon;
